import { Box, Stack, Typography } from '@mui/material';
import type { AuditLogEntry } from '../../types/audit';

interface Props {
  entry: AuditLogEntry;
}

const formatValue = (v: unknown): string => {
  if (v === null || v === undefined) return '—';
  if (typeof v === 'boolean') return v ? 'Ano' : 'Ne';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

export const AuditDiffView = ({ entry }: Props) => {
  const oldVals = entry.oldValues ?? {};
  const newVals = entry.newValues ?? {};
  const keys = Array.from(
    new Set([...Object.keys(oldVals), ...Object.keys(newVals)]),
  );

  if (keys.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Bez detailů změn.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1, alignItems: 'start' }}>
      <Typography variant="caption" fontWeight="bold">Pole</Typography>
      <Typography variant="caption" fontWeight="bold" color="error">Před</Typography>
      <Typography variant="caption" fontWeight="bold" color="success.main">Po</Typography>
      {keys.map((key) => (
        <Stack key={key} direction="row" sx={{ gridColumn: 'span 3' }}>
          <Box sx={{ flex: 1, pr: 1, wordBreak: 'break-word' }}>
            <Typography variant="body2" color="text.secondary">{key}</Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              pr: 1,
              wordBreak: 'break-word',
              bgcolor: 'error.light',
              opacity: 0.85,
              px: 1,
              py: 0.5,
              borderRadius: 0.5,
              mr: 0.5,
            }}
          >
            <Typography variant="body2">{formatValue(oldVals[key])}</Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              wordBreak: 'break-word',
              bgcolor: 'success.light',
              opacity: 0.85,
              px: 1,
              py: 0.5,
              borderRadius: 0.5,
            }}
          >
            <Typography variant="body2">{formatValue(newVals[key])}</Typography>
          </Box>
        </Stack>
      ))}
    </Box>
  );
};
